export default "__VITE_ASSET__nHPn1qGG__"